import React, {useEffect, useRef} from "react";
import styles from "./Graph.module.scss";
import {isInViewport} from "../../Functions";
import gsap from "gsap";

export default function MutationRemote() {
    const element = useRef(null);

    useEffect(() => {
        const bars = element.current.querySelectorAll('.bar-wrapper rect');
        const numbers = element.current.querySelectorAll('.bar-wrapper text');

        gsap.set([bars], {
            attr: {
                transform: "scale(1,0)"
            }
        });

        gsap.set(numbers, {
            opacity: 0
        });

        if (element.current && !element.current.classList.contains('animated')) {
            window.addEventListener('scroll', () => {
                if (isInViewport(element.current)) {
                    Object.values(bars).map((bar, index) =>
                        gsap.to(bar, .7, {
                            transform: 'scale(1, 1)',
                            delay: .1 * index,
                            onComplete: () => {
                                gsap.to(numbers[index], .3, {
                                    opacity: 1
                                })
                            }
                        })
                    );

                    element.current.classList.add('animated');
                }
            })
        }
    }, []);

    const svg = `
<svg width="918px" height="419px" viewBox="0 0 918 419" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -4.000000)">
            <g>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="0.0400390625" y="14">90 </tspan>
                    <tspan x="18.2578125" y="14" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="1.72851562" y="188">45</tspan>
                    <tspan x="16.5693359" y="188" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <text font-family="OpenSans-Semibold, Open Sans" font-size="13" font-weight="500" fill="#000000">
                    <tspan x="5.4387207" y="363">0</tspan>
                    <tspan x="12.8591309" y="363" font-family="OpenSans-Regular, Open Sans" font-weight="normal">%</tspan>
                </text>
                <path d="M13.5,23.5 L13.5,165.5" stroke="#9B9B9B" opacity="0.495575678" stroke-linecap="square"></path>
                <path d="M13.5,199.5 L13.5,341.5" stroke="#9B9B9B" opacity="0.495575678" stroke-linecap="square"></path>
            </g>
            <g transform="translate(70.000000, 18.000000)">
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" line-spacing="20" fill="#000000">
                    <tspan x="44.7841797" y="381">Outils de </tspan>
                    <tspan x="26.3198242" y="401">collaborations</tspan>
                </text>
                
                <g class="bar-wrapper">
                    <rect fill="#EFADAC" x="0" y="126" width="75" height="220" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                        <tspan x="22.1813965" y="150">55%</tspan>
                    </text>
                </g>
                
                <g class="bar-wrapper">
                    <rect fill="#DC615F" x="77" y="30" width="75" height="316" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                    <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                        <tspan x="99.1813965" y="56">79%</tspan>
                    </text>
                </g>
                
                <path d="M0,121.5 L0,30.5 L74,30.5" stroke="#9B9B9B" opacity="0.502628871" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4,4"></path>
                <g transform="translate(6.000000, 0.000000)">
                    <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                        <tspan x="18.1132812" y="17">= 44%</tspan>
                    </text>
                    <polygon fill="#56A51C" points="7 7.86898804 14 18.868988 0 18.868988"></polygon>
                </g>
            </g>
            <g transform="translate(302.000000, 38.000000)">
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" line-spacing="20" fill="#000000">
                    <tspan x="44.7841797" y="361">Outils de</tspan>
                    <tspan x="11.6347656" y="381">stockage / partage</tspan>
                </text>
                                <g class="bar-wrapper">

                <rect fill="#EFADAC" x="0" y="70" width="75" height="256" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="22.1813965" y="96">64%</tspan>
                </text>
                </g>
                                <g class="bar-wrapper">

                <rect fill="#DC615F" x="77" y="30" width="75" height="296" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="99.1813965" y="56">74%</tspan>
                </text>
                </g>
                <path d="M0,66.5 L0,30.5 L74,30.5" stroke="#9B9B9B" opacity="0.502628871" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4,4"></path>
                <g transform="translate(6.000000, 0.000000)">
                    <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                        <tspan x="18.1132812" y="17">= 16%</tspan>
                    </text>
                    <polygon fill="#56A51C" points="7 7.86898804 14 18.868988 0 18.868988"></polygon>
                </g>
            </g>
            <g transform="translate(497.000000, 176.000000)">
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" line-spacing="20" fill="#000000">
                    <tspan x="23.0439453" y="223">Outils de formation ou de </tspan>
                    <tspan x="20.7368164" y="243">développement personnel</tspan>
                </text>
                                <g class="bar-wrapper">

                <rect fill="#EFADAC" x="37" y="0" width="75" height="188" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="59.1813965" y="26">47%</tspan>
                </text>
                </g>
                                <g class="bar-wrapper">

                <rect fill="#DC615F" x="114" y="0" width="75" height="188" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="136.181396" y="26">47%</tspan>
                </text>
                </g>
            </g>
            <g transform="translate(766.000000, 14.000000)">
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" line-spacing="20" fill="#000000">
                    <tspan x="2.84204102" y="385">Outils de messagerie </tspan>
                    <tspan x="1.8605957" y="405">mobile en temps réel</tspan>
                </text>
                                <g class="bar-wrapper">

                <rect fill="#EFADAC" x="0" y="50" width="75" height="300" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="22.1813965" y="76">75%</tspan>
                </text>
                </g>
                                <g class="bar-wrapper">

                <rect fill="#DC615F" x="77" y="30" width="75" height="320" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="99.1813965" y="56">80%</tspan>
                </text>
                </g>
                <path d="M0,47.5 L0,30.5 L74,30.5" stroke="#9B9B9B" opacity="0.502628871" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4,4"></path>
                <g transform="translate(6.000000, 0.000000)">
                    <text font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                        <tspan x="22.6875" y="17">= 7%</tspan>
                    </text>
                    <polygon fill="#56A51C" points="7 7.86898804 14 18.868988 0 18.868988"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>`;

    const legend = `
<svg width="284px" height="16px" viewBox="0 0 284 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-296.000000, -12492.000000)">
            <g transform="translate(20.000000, 10808.000000)">
                <g transform="translate(0.000000, 800.000000)">
                    <g transform="translate(0.000000, 594.000000)">
                        <g transform="translate(206.000000, 287.000000)">
                            <g transform="translate(70.000000, 0.000000)">
                                <text font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" fill="#000000">
                                    <tspan x="26" y="14">2019 (n = 7,261)</tspan>
                                </text>
                                <rect fill="#EFADAC" x="0" y="3" width="16" height="16"></rect>
                                <text font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" fill="#000000">
                                    <tspan x="188" y="14">2021 (n = 8,253)</tspan>
                                </text>
                                <rect fill="#DC615F" x="162" y="3" width="16" height="16"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;
    return (
        <div className={styles.Column} ref={element}>
            <div dangerouslySetInnerHTML={{__html: legend}}/>

            <div dangerouslySetInnerHTML={{__html: svg}}/>
        </div>
    )
}
